import { render, staticRenderFns } from "./TabItem.vue?vue&type=template&id=020c33e8&scoped=true&lang=pug&"
import script from "./TabItem.vue?vue&type=script&lang=ts&"
export * from "./TabItem.vue?vue&type=script&lang=ts&"
import style0 from "./TabItem.vue?vue&type=style&index=0&id=020c33e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020c33e8",
  null
  
)

export default component.exports